<template>
  <div class="select-course-assistant-grade-list">
    <card title="您孩子现在几年级？">
      <div class="select-course-assistant-grade-list-item"
           v-for="(item, index) in list"
           :key="index"
           @click="handleClickItem(item.id)"
      >
        {{ item.name }}
      </div>
    </card>
  </div>
</template>

<script>
  import Card from '@/pages/SelectCourseAssistant/components/Card';

  export default {
    name: 'SelectCourseAssistantGradeListPage',
    components: {
      Card,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
      vip: {
        type: Array,
        required: true,
      },
    },
    methods: {
      handleClickItem(id) {
        if (id === 2) {
          this.$emit('show-category');
          return;
        }
        const answer = id === 1 ? this.vip[0].answer : this.vip[1].answer;
        this.$router.push({
          name: 'SelectCourseAssistantRecommend',
          query: {
            answer,
            path: this.vip[0].path,
            id: this.vip[0].id,
          },
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .select-course-assistant-grade-list {
    height: 100%;
    &-title {
      margin-bottom: @size-medium;
      color: @color-text-base;
      font-size: @font-size-large;
      font-weight: @font-weight-bold;
      line-height: 1.5;
    }
    &-item {
      width: 590px;
      height: 112px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-text-base;
      font-size: 30px;
      background: @background-color-lighter;
      border-radius: 20px;

      &:not(:last-child) {
        margin-bottom: @size-base;
      }
    }
  }

</style>
